module.exports = require('./Game');



// WEBPACK FOOTER //
// ./src/Breakout.js